import { EditIconTwoTone, TrashErrorIconTwoTone } from '@room-match/shared-ui-components';
import { FC, Fragment } from 'react';
import { CustomIconButton } from './ActionButton.styles';

type ActionButtonProps = {
  onEdit?: VoidFunction;
  onDelete?: VoidFunction;
};

const ActionButton: FC<ActionButtonProps> = ({ onEdit, onDelete }) => {
  return (
    <Fragment>
      <CustomIconButton
        onClick={(e) => {
          e.stopPropagation();
          if (onEdit) onEdit();
        }}
      >
        <EditIconTwoTone fontSize="inherit" />
      </CustomIconButton>
      <CustomIconButton
        onClick={(e) => {
          e.stopPropagation();
          if (onDelete) onDelete();
        }}
      >
        <TrashErrorIconTwoTone fontSize="inherit" />
      </CustomIconButton>
    </Fragment>
  );
};

export default ActionButton;
